module.exports = __webpack_public_path__ + "img/logo_nav.2d514964.png";